/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Member_Seat_Type_Schedule_CancelledInputs */



/**
* | output |
* | --- |
* | "Seat type change cancelled" |
*
* @param {Audit_Details_Member_Seat_Type_Schedule_CancelledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_member_seat_type_schedule_cancelled = /** @type {((inputs?: Audit_Details_Member_Seat_Type_Schedule_CancelledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Member_Seat_Type_Schedule_CancelledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sitztypänderung abgebrochen")
	return /** @type {LocalizedString} */ ("Seat type change cancelled")
});